<script setup>
import { ref } from 'vue'
import Input from './Input.vue'
import ResponseModal from './ResponseModal.vue';

const name = ref('')
const email = ref('')
const phone = ref('')
const message = ref('')

const isSent = ref(false);
const isSuccess = ref(false);

function resetForm() {
  name.value = ''
  email.value = ''
  phone.value = null
  message.value = ''
}

function closeModal() {
  isSent.value = false
  isSuccess.value = false
}

function validateForm() {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (!email.value || !emailRegex.test(email.value)) {
    return false
  }

  return !(String(name.value).trim() === '' || String(phone.value).trim() === '');
}

function onSubmit() {
  if (validateForm()) {
    const formdata = new FormData();
    formdata.append('id', 'Galazia');
    formdata.append('name', `${name.value}`);
    formdata.append('email', `${email.value}`);
    formdata.append('subject', "Galazia website request");
    formdata.append('message', `${message.value}\nUser phone number: ${phone.value}`);
    formdata.append('emailto', "info@galazia.com");

    const request = {
      method: 'POST',
      body: formdata,
      mode: 'no-cors',
    };

    fetch('https://license.darmius.kz/sendmail', request)
        .then(response => {
          isSent.value = true;
          isSuccess.value = true;
          resetForm();
        })
        .catch(e => {
          isSent.value = true;
          isSuccess.value = false;
          resetForm();
        });
  }
}
</script>

<template>
  <form @submit.prevent="onSubmit" class="form relative">
    <div class="form-inputs flex flex-col">
      <Input placeholder="Name" v-model="name" name="name" />
      <Input placeholder="Email" type="email" v-model="email" name="email" />
      <Input placeholder="Phone number" type="tel" v-model="phone" name="phone" />
      <Input placeholder="How can we help?" type="textarea" v-model="message" name="message" textarea />
    </div>
    <button type="submit"><p>Send</p></button>
  </form>
  <ResponseModal :open="isSent" :success="isSuccess" @close="closeModal" />
</template>

<style scoped lang="scss">
.form {
  width: clamp(591px, 41.111vw, 3000px);
  display: flex;
  flex-direction: column;
  z-index: 2;
  button {
    margin-top: 3.056vw;
    outline: none;
    width: clamp(154px, 10.694vw, 770px);
    height: clamp(48px, 3.333vw, 240px);
    padding: clamp(14px, 0.972vw, 70px) clamp(21px, 1.458vw, 105px);
    cursor: pointer;
    border-radius: clamp(4px, 0.278vw, 20px);
    border: 1px solid #FFF;
    background: #4D46F8;
    box-shadow: 0px 4px 18px 0px rgba(255, 255, 255, 0.25);
    transition: background .3s ease;

    p {
      color: #FFF;
      font-family: "Orbitron", sans-serif;
      font-weight: 800;
      text-transform: capitalize;
      transition: color .3s ease;
    }
    &:hover {
      background: #FFF;
      p {
        color: #4D46F8;
      }
    }
  }
}

@media (max-width: 768px) {
  .form {
    width: 100%;
    button {
      margin-top: 44px;
    }
  }
}
</style>
